import { useMemo, useState } from 'react';
import { colors } from 'ui/theme/colors';

import { UrlInputProps } from './types';

export const useUrlInputController = ({
  type,
  label,
  _formControl,
  hasError,
  control,
  name,
  isInvalid,
  leftIconErrorSize = 16,
  defaultCountry = 'GB',
  value,
  isDisabled,
  isRequired,
  isReadOnly,
  errorMessage,
  helperText,
  iconErrorMessage,
  leftIconName,
  leftIconColor = colors.gray[500],
  leftIconSize = 16,
  rightIconColor = colors.gray[500],
  rightIconSize = 16,
  rightIconName,
  isShowPasswordToggle = true,
  showPasswordRules,
  onChange,
  ...restProps
}: UrlInputProps) => {
  const [currentType, setCurrentType] = useState(type);

  const toggleShowPasswordType = () => {
    setCurrentType((prev) => (prev === 'password' ? 'text' : 'password'));
  };

  const isPasswordField = useMemo(() => type === 'password', [type]);

  const hasErrorOrErrorMessage = useMemo(
    () => hasError || errorMessage,
    [errorMessage, hasError],
  );

  return {
    leftIconName,
    leftIconColor,
    leftIconSize,
    label,
    _formControl,
    hasError,
    hasErrorOrErrorMessage,
    isInvalid,
    isDisabled,
    value,
    isRequired,
    isReadOnly,
    errorMessage,
    defaultCountry,
    iconErrorMessage,
    rightIconName,
    helperText,
    rightIconColor,
    control,
    name,
    rightIconSize,
    leftIconErrorSize,
    currentType,
    isShowPasswordToggle,
    isPasswordField,
    showPasswordRules,
    restProps,
    onChange,
    toggleShowPasswordType,
  };
};
